module.exports = __webpack_public_path__ + "img/kia-ScheduleService.89c45b18.png";